export default function stopPropagationListener(event) {
    event.stopPropagation();
}
